/* eslint-disable  */
import { Menu, MenuItem } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { MenuTwoLineIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { FiBell, FiHeart, FiLogOut, FiMessageSquare, FiSettings, FiShoppingCart, FiUser } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import "../../../../css/Dashboard/home/Home.css";
import {
  messagesActionCreators,
  navigationActionCreators,
} from "../../../../service/action-creators";

// Badges cap out rather than stretching the bar when someone has 300 unread.
const badgeLabel = (count) => {
  const n = Number(count) || 0;
  if (!n) return null;
  return n > 99 ? "99+" : String(n);
};

const NAV_LINKS = [
  { to: "/home", label: "Overview" },
  { to: "/supports", label: "Support" },
];

function NavAction({ icon: Icon, label, count, onClick, tone }) {
  const badge = badgeLabel(count);
  return (
    <button type="button" className="navAction" onClick={onClick} title={label} aria-label={label}>
      <Icon size={18} className={tone === "love" && badge ? "navAction-love" : ""} />
      {badge ? <span className="navAction-badge">{badge}</span> : null}
    </button>
  );
}

function SmallNavBar() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const auth = useSelector((state) => state?.auth);
  const messages = useSelector((state) => state?.messages);
  const user = auth?.user;

  // Cache-buster on the avatar, so a freshly uploaded photo isn't served from
  // the old cached response — but not on pre-signed URLs, where an extra query
  // string breaks the signature.
  const timestamp = new Date().getTime();
  const buildImageUrl = (url) => {
    if (!url) return url;
    if (url.includes("X-Amz-Signature")) return url;
    return `${url}?${timestamp}`;
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const { openSideBarOnMobile } = bindActionCreators(navigationActionCreators, dispatch);
  const { GetTotalUnreadMessages } = bindActionCreators(messagesActionCreators, dispatch);

  const cart = useSelector((state) => state?.user?.cart);
  const favoriteProducts = useSelector((state) => state?.user?.favoriteProducts);
  const notifications = useSelector((state) => state?.notification?.notifications);

  useEffect(() => {
    GetTotalUnreadMessages();
  }, []);

  const goTo = (path) => () => history.push(path);

  const firstName = user?.name?.split(" ")?.[0] || "";
  const initials = (user?.name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

  const [avatarBroken, setAvatarBroken] = useState(false);
  const avatar = user?.profile_image && !avatarBroken ? buildImageUrl(user.profile_image) : null;

  return (
    <div className="SmallNavBar">
      <div className="menuLinks">
        {/* Menu button — the only way into the side panel on small screens. */}
        <button
          type="button"
          className="navBurger"
          onClick={openSideBarOnMobile}
          aria-label="Open menu"
        >
          <HugeiconsIcon icon={MenuTwoLineIcon} size={22} strokeWidth={1.8} />
        </button>

        {/* <div className="navBrand">
          <span className="navBrand-mark">UP</span>
          <span className="navBrand-text">Nurses Portal</span>
        </div> */}

        <nav className="navLinks">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={location.pathname === link.to ? "navLink navLink-active" : "navLink"}
            >
              {link.label}
            </Link>
          ))}
          <a href="https://upnmg.com" target="_blank" rel="noreferrer" className="navLink">
            UPNMG Website
          </a>
        </nav>
      </div>

      <div className="userProfile">
        <NavAction
          icon={FiMessageSquare}
          label="Messages"
          count={messages?.unreadMessagesTotal}
          onClick={goTo("/message")}
        />
        <NavAction
          icon={FiBell}
          label="Notifications"
          count={notifications?.length}
          onClick={goTo("/notifications")}
        />
        <NavAction
          icon={FiHeart}
          label="Favourites"
          count={favoriteProducts?.length}
          tone="love"
          onClick={goTo("/favourites")}
        />
        <NavAction
          icon={FiShoppingCart}
          label="Cart"
          count={cart?.length}
          onClick={goTo("/my-cart")}
        />

        <button
          type="button"
          className="navProfile"
          id="demo-positioned-button"
          aria-controls={open ? "demo-positioned-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          {avatar ? (
            <img
              className="navProfile-avatar"
              src={avatar}
              alt=""
              onError={() => setAvatarBroken(true)}
            />
          ) : (
            <span className="navProfile-avatar navProfile-initials">{initials || "?"}</span>
          )}
          <span className="navProfile-name">{firstName}</span>
          <span className="navProfile-caret" aria-hidden="true" />
        </button>

        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          getContentAnchorEl={null}
        >
          <MenuItem
            onClick={() => {
              history.push("/profile");
              handleClose();
            }}
          >
            <FiUser size={15} style={{ marginRight: 10 }} /> My Profile
          </MenuItem>
          <MenuItem
            onClick={() => {
              history.push("/my-cart");
              handleClose();
            }}
          >
            <FiShoppingCart size={15} style={{ marginRight: 10 }} /> My Cart
          </MenuItem>
          <MenuItem
            onClick={() => {
              history.push("/settings");
              handleClose();
            }}
          >
            <FiSettings size={15} style={{ marginRight: 10 }} /> Settings
          </MenuItem>
          <MenuItem
            onClick={() => {
              history.push("/logout");
              handleClose();
            }}
          >
            <FiLogOut size={15} style={{ marginRight: 10 }} /> Logout
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default SmallNavBar;
